import { useMemo } from 'react';

import { renderMarkdown } from '../../utils/markdown';

/**
 * Read-only rendering of a 'rich-text' element value. The markdown is
 * rendered and sanitized in utils/markdown.js (allowlist — scripts, images,
 * and event handlers never survive), so the raw injection here is safe.
 */
export default function MarkdownContent ( { markdown, className = '' } ) {

	const html = useMemo( () => renderMarkdown( markdown ), [ markdown ] );

	if ( !html ) return null;

	return (
		<div
			className={'markdown-content' + ( className ? ' ' + className : '' )}
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	);

}
